import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../assets/css/us.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
// import Mail from './email';

const Us = () => {
    const { t } = useTranslation();
    const [visibleCards, setVisibleCards] = useState(0);
    const cards = useMemo(() => [
        {
            name: 'Ezequiel Martínez',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/bd-andivi.firebasestorage.app/o/Mixtecnautas%2FCheke1.jpeg?alt=media&token=03dfa208-a279-4548-a808-f8e06a54214c',
            linkedin: 'https://www.linkedin.com/in/ezequiel-martinez-475088329/',
            title: t('ezequiel_title'),
            role:'engineer'
        },
        {
            name: 'Michelle Suhey',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/utemitas.appspot.com/o/mich.jpeg?alt=media&token=3307df9e-71b7-4345-a416-36ec505affa5',
            linkedin: 'https://www.linkedin.com/in/michelle-suhey-palacios-santos-0408b82a1/',
            title: t('michelle_title'),
        },
        {
            name: 'Erick Chávez',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/utemitas.appspot.com/o/erik.jpeg?alt=media&token=2c82d10c-a97d-4c2d-9888-590cb54804aa',
            linkedin: 'https://www.linkedin.com/in/zevach98/',
            title: t('erick_title'),
            role:'engineer'
        },
        {
            name: 'Tomás',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/bd-andivi.firebasestorage.app/o/Mixtecnautas%2FTomas.JPG?alt=media&token=e1484ed1-4c53-422f-a6c9-141d8cda8e8c',
            linkedin: 'https://www.linkedin.com/in/tom%C3%A1s-osorio-de-los-%C3%A1ngeles-31743131a/',
            title: t('tomas_title'),
            role:'engineer'
        },
        {
            name: 'Emma',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/utemitas.appspot.com/o/emma.jpeg?alt=media&token=d0c269a5-580c-4b3f-8cc8-3f5bd33a4a83',
            linkedin: 'https://www.linkedin.com/in/esmeralda-galindo-0917051ba/',
            title: t('emma_title'),
            role:'engineer'
        },
        {
            name: 'Alejandro',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/bd-andivi.firebasestorage.app/o/Mixtecnautas%2FYo.jpg?alt=media&token=25ae2642-e173-475b-9f02-8ba99fa42f39',
            linkedin: 'https://www.linkedin.com/in/alejandro-barragan-80b696285/',
            title: t('alejandro_title'),
            role:'engineer'
        },
        {
            name: 'Jorge',
            imgSrc: 'https://firebasestorage.googleapis.com/v0/b/bd-andivi.firebasestorage.app/o/Mixtecnautas%2FGeorge.jpg?alt=media&token=f9e193de-4630-4d1c-b9d8-dfad2f3d8945',
            linkedin: 'https://www.linkedin.com/in/jorge-arturo-carrasco-jim%C3%A9nez-037659188/',
            title: t('jorge_title'),
            role:'master'
        },
    ], [t]);

    const old = useMemo(()=>[
        {
            name: 'Omar Cruz',
            imgSrc:'https://firebasestorage.googleapis.com/v0/b/utemitas.appspot.com/o/yo.jpeg?alt=media&token=d310b061-2b32-4a8a-88f3-0c69eb91af02',
            linkedin: 'https://www.linkedin.com/in/omar-cruzr97/',
            title:t('omar_title'),
            role:'engineer',
            time:'05/oct/2024 - 18/jun/2025'
        }

    ],[t]);

    useEffect(() => {
        const kofiElement = document.querySelector(`.${Style.kofi}`);
        const interval = setInterval(() => {
            kofiElement.classList.toggle(Style.vibrate);
        }, 2000);
    
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (visibleCards < cards.length) {
            setTimeout(() => {
                setVisibleCards(visibleCards + 1);
            }, 300);
        }
    }, [visibleCards, cards.length]);

    return (
        <>
            <section className={Style.team}>
            <section className={Style.usContainer}>
                <div className={Style.contributors}>
                    <h2 className={Style.contributorsTitle}>{t('meet_the_team')}</h2>
                    <div className={Style.kofi}>
                        <a
                            href="https://ko-fi.com/andivi_nundoo"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={Style.koFiButton}
                        >
                            <img
                                src="./ko-fi.webp"
                                alt="Ko-fi"
                                className={Style.koFiImage}
                            />
                            {t('buy_us_a_coffee')}
                        </a>
                    </div>
                    <div className={Style.contributorsTeam}>
                        {cards.map((card, index) => (
                            <div key={index} className={`${Style.card} ${index < visibleCards ? Style.visible : ''}`}>
                                <div className={Style.profilePic}>
                                    <img src={card.imgSrc} alt={card.name} />
                                </div>
                                <div className={Style.bottom}>
                                    <div className={Style.content}>
                                        <span className={Style.name}>
                                            {card.role === 'master' ? t('master') : t('engineer')} {card.name}
                                        </span>
                                        <span className={Style.aboutMe}>{card.title}</span>
                                    </div>
                                    <div className={Style.bottomBottom}>
                                        <div className={Style.socialLinksContainer}>
                                            <a href={card.linkedin} target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faLinkedin} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className={Style.oldMembers}>
                <div className={Style.contributors}>
                    <h2 className={Style.contributorsTitle}>{t('old_members')}</h2>
                    <div className={Style.contributorsTeam}>
                        {old.map((old, index) => (
                            <div key={index} className={`${Style.card} ${index < visibleCards ? Style.visible : ''}`}>
                                <div className={Style.profilePic}>
                                    <img src={old.imgSrc} alt={old.name} /> 
                                </div>
                                <div className={Style.bottom}>
                                    <div className={Style.content}>
                                        <span className={Style.name}>
                                            
                                            {old.role === 'master' ? t('master') : t('engineer')} {old.name}
                                        </span>
                                        <span className={Style.aboutMe}>{old.time}</span>
                                    
                                        <span className={Style.aboutMe}>{old.title}</span>
                                        
                                    </div>
                                    <div className={Style.bottomBottom}>
                                        <div className={Style.socialLinksContainer}>
                                            <a href={old.linkedin} target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faLinkedin} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </section>
            {visibleCards === old.length }
            </section>
        </>
    );
}

export default Us;